import * as yup from "yup";


export const positiveNumber = yup.number()
    .positive('Deve essere un numero positivo')
    .typeError('Deve essere un numero');


export const nonNegativeNumber = yup.number()
    .min(0, 'Deve essere un numero non negativo')
    .typeError('Deve essere un numero');

export const positiveNumberRequired = positiveNumber.required('Campo obbligatorio');
export const nonNegativeNumberRequired = nonNegativeNumber.required('Campo obbligatorio');


